// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateFacetsRegistrationDateRange = dateRange => ({
    dateRange,
    type: actions.UPDATE_REGISTRATION_FACETS_DATE_RANGE
});

export const updateFacetsDeliveryDateRange = dateRange => ({
    dateRange,
    type: actions.UPDATE_DELIVERY_FACETS_DATE_RANGE
});

export const updateDealerAccountFacetInput = value => ({
    type: actions.UPDATE_REGISTRATION_DEALER_ACCOUNT_FACET_INPUT,
    value
});

export const updateDealerAccountFacetItem = (dealerAccount, isSelected) => ({
    dealerAccount,
    isSelected,
    type: actions.UPDATE_DEALER_ACCOUNT_FACET_ITEM
});

export const toggleDealerAccountFacetItems = allowedDealers => ({
    allowedDealers,
    type: actions.TOGGLE_DEALER_ACCOUNT_FACET_ITEMS
});

export const selectAllDealersOnInitialLoad = allowedDealers =>
    dispatch => {

        dispatch({
            allowedDealers,
            type: actions.UPDATE_REGISTRATION_FACET_ITEMS_ON_LOAD
        });

        dispatch({
            allowedDealers,
            type: actions.UPDATE_TRANSFER_APPROVAL_FACET_ITEMS_ON_LOAD
        });

        dispatch({
            allowedDealers,
            type: actions.UPDATE_TRANSFER_RECOMMENDATION_FACET_ITEMS_ON_LOAD
        });

    };



// WEBPACK FOOTER //
// ./src/product/machine-status-update/action-creators/facets.js